export * from './apolloDocument.service';
import { ApolloDocumentService } from './apolloDocument.service';
export * from './apolloDocumentLineResource.service';
import { ApolloDocumentLineResourceService } from './apolloDocumentLineResource.service';
export * from './apolloDocumentResource.service';
import { ApolloDocumentResourceService } from './apolloDocumentResource.service';
export * from './applicationModuleResource.service';
import { ApplicationModuleResourceService } from './applicationModuleResource.service';
export * from './contextGroupResource.service';
import { ContextGroupResourceService } from './contextGroupResource.service';
export * from './contextModuleResource.service';
import { ContextModuleResourceService } from './contextModuleResource.service';
export * from './contextUserEopooResource.service';
import { ContextUserEopooResourceService } from './contextUserEopooResource.service';
export * from './contextUserResource.service';
import { ContextUserResourceService } from './contextUserResource.service';
export * from './customRolePermissionResource.service';
import { CustomRolePermissionResourceService } from './customRolePermissionResource.service';
export * from './customRoleResource.service';
import { CustomRoleResourceService } from './customRoleResource.service';
export * from './entityReferenceResource.service';
import { EntityReferenceResourceService } from './entityReferenceResource.service';
export * from './eopooApiController.service';
import { EopooApiControllerService } from './eopooApiController.service';
export * from './fatturaPa.service';
import { FatturaPaService } from './fatturaPa.service';
export * from './permissionResource.service';
import { PermissionResourceService } from './permissionResource.service';
export * from './roleAssignationResource.service';
import { RoleAssignationResourceService } from './roleAssignationResource.service';
export * from './roleResource.service';
import { RoleResourceService } from './roleResource.service';
export * from './tenantContextResource.service';
import { TenantContextResourceService } from './tenantContextResource.service';
export * from './userPermissionMemoryResource.service';
import { UserPermissionMemoryResourceService } from './userPermissionMemoryResource.service';
export * from './userResource.service';
import { UserResourceService } from './userResource.service';
export * from './userToContextResource.service';
import { UserToContextResourceService } from './userToContextResource.service';
export * from './verifyUserPermissionApiController.service';
import { VerifyUserPermissionApiControllerService } from './verifyUserPermissionApiController.service';
export * from './wsUserContext.service';
import { WsUserContextService } from './wsUserContext.service';
export const APIS = [ApolloDocumentService, ApolloDocumentLineResourceService, ApolloDocumentResourceService, ApplicationModuleResourceService, ContextGroupResourceService, ContextModuleResourceService, ContextUserEopooResourceService, ContextUserResourceService, CustomRolePermissionResourceService, CustomRoleResourceService, EntityReferenceResourceService, EopooApiControllerService, FatturaPaService, PermissionResourceService, RoleAssignationResourceService, RoleResourceService, TenantContextResourceService, UserPermissionMemoryResourceService, UserResourceService, UserToContextResourceService, VerifyUserPermissionApiControllerService, WsUserContextService];
